import React from "react";
import { useNavigate } from "react-router-dom";
import "./NotFound.scss";
import { getLocalizedValueSync } from "../../services/localizationService";
 
const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  const localizedTittle = getLocalizedValueSync("CA.Notfound.title") || "";
  const localizedMessage = getLocalizedValueSync("CA.Notfound.message") || "";
  const localizedLinktext = getLocalizedValueSync("CA.Notfound.linktext") || "";
  const localizedEndMessage = getLocalizedValueSync("CA.Notfound.endmessage") || "";

  return (
    <div className="not-found-container">
      <h2 className="not-found-title">{localizedTittle}</h2>
      <p className="not-found-message">
        {localizedMessage}{" "}
        <span className="not-found-link" onClick={handleGoHome}>
         {localizedLinktext} 
        </span>{" "}
        {localizedEndMessage}
      </p>
    </div>
  );
};

export default NotFound;
